import React, { useState, useEffect } from "react";
import { Link, NavLink} from "react-router-dom";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50
        flex items-center justify-between
        px-5 py-3 md:px-8 lg:px-12
        transition-all duration-300
        ${scrolled
          ? "bg-black/80 shadow-lg backdrop-blur-xl border-b border-white/10"
          : "bg-black/80"
        }
      `}
    >
      {/* Logo */}
      <div className="flex-shrink-0">
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img
            src="/logo512.png"
            alt="SERVICE IPTV Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <ul
        className={`
          hidden md:flex
          items-center
          gap-8
          list-none
          m-0 p-0
        `}
      >
        <li>
          <Link
            to="/"
            className="text-white font-medium transition-colors duration-200 hover:text-blue-400"
          >
            Home
          </Link>
        </li>

        <li>
          <Link
            to="/pricing"
            className="text-white font-medium transition-colors duration-200 hover:text-blue-400"
          >
            Pricing
          </Link>
        </li>

        <li>
          <Link
            to="/About"
            className="text-white font-medium transition-colors duration-200 hover:text-blue-400"
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="/faq"
            className="text-white font-medium transition-colors duration-200 hover:text-blue-400"
          >
            Faq
          </Link>
        </li>
        <li>
          <Link
            to="/blog"
            className="text-white font-medium transition-colors duration-200 hover:text-blue-400"
          >
            Blog
          </Link>
        </li>

        <li>
          <Link
            to="/contact"
            className="text-white font-medium transition-colors duration-200 hover:text-blue-400"
          >
            Contact
          </Link>
        </li>
      </ul>

      {/* Free Trial Button - Desktop */}
     <NavLink  className="
          hidden md:block
          rounded-full
          bg-blue-600
          px-6 py-3
          text-sm font-semibold text-white
          shadow-lg shadow-blue-600/20
          transition-all duration-300
          hover:bg-blue-500
          hover:scale-105
        " to="/free-trial">

       
      
        Free Trial 24h
     </NavLink>

      {/* Mobile Burger */}
      <button
        type="button"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        onClick={() => setMenuOpen(!menuOpen)}
        className="
          md:hidden
          flex items-center justify-center
          rounded-lg
          p-2
          text-white
          transition
          hover:bg-white/10
        "
      >
        {menuOpen ? <X size={26} /> : <Menu size={26} />}
      </button>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="
            absolute
            top-full
            left-0
            right-0
            bg-black/95
            border-t border-white/10
            shadow-xl
            backdrop-blur-xl
            md:hidden
          "
        >
          <ul className="flex flex-col list-none m-0 p-5 gap-2">
            <li>
              <Link
                to="/"
                onClick={() => setMenuOpen(false)}
                className="
                  block rounded-lg
                  px-4 py-3
                  text-white font-medium
                  transition
                  hover:bg-white/10
                  hover:text-blue-400
                "
              >
                Home
              </Link>
            </li>

            <li>
              <Link
                to="/pricing"
                onClick={() => setMenuOpen(false)}
                className="
                  block rounded-lg
                  px-4 py-3
                  text-white font-medium
                  transition
                  hover:bg-white/10
                  hover:text-blue-400
                "
              >
                Pricing
              </Link>
            </li>

            <li>
              <Link
                to="/About"
                onClick={() => setMenuOpen(false)}
                className="
                  block rounded-lg
                  px-4 py-3
                  text-white font-medium
                  transition
                  hover:bg-white/10
                  hover:text-blue-400
                "
              >
                About
              </Link>
            </li>

            <li>
              <Link
                to="/Blog"
                onClick={() => setMenuOpen(false)}
                className="
                  block rounded-lg
                  px-4 py-3
                  text-white font-medium
                  transition
                  hover:bg-white/10
                  hover:text-blue-400
                "
              >
                Blog
              </Link>
            </li>

            <li>
              <Link
                to="/contact"
                onClick={() => setMenuOpen(false)}
                className="
                  block rounded-lg
                  px-4 py-3
                  text-white font-medium
                  transition
                  hover:bg-white/10
                  hover:text-blue-400
                "
              >
                Contact
              </Link>
            </li>

            {/* Mobile Trial Button */}
            <li className="pt-3">


             

              <NavLink  className="
              w-full
              rounded-full
              bg-blue-600
              px-6 py-3
              text-sm font-semibold text-white
              shadow-lg shadow-blue-600/20
              transition-all duration-300
              hover:bg-blue-500
              " to="/free-trial">
                Essai gratuit
              </NavLink>

            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Header;